import { GridValidRowModel } from '@mui/x-data-grid-pro';

interface UserRawFields {
	code: string;
	name: string;
}

export type User = GridValidRowModel & {
	code: string;
	name: string;
};

export function transformUserResponse(result: UserRawFields[] | undefined): User[] {
	return result ? sortUsers(result) : [];
}

/** Method for sorting Users */
export function sortUsers(users: User[]) {
	return users.sort((a, b) => {
		// sort by User Name
		return a.name.localeCompare(b.name, 'en', {
			sensitivity: 'base'
		});
	});
}
